import { rolesColors, rolesTranslations } from '../../services/data'

const explained = [
    'מציע רעיון ראשוני, מיקום,כותרת,תקציר וטאמבנייל אופציונלי.',
    'עורך טבלה ובה כל הפריטים שהסרטון עשוי להצטרך.',
    'כותב תסריט ומצרף טבלה נוספת של מה צריך כדי לגרום לתסריט לקרות.',
    'סוגר בפועל את הדברים שהתסריטאי צריך, מוסיף מחיר לטבלת הפריטים ועורך את לוח השנה בהתאם לזמנים שנקבעו.',
    'מצרף עד 3 טאמבניילים לסרטון. יכול לעשות זאת תוך כדי בכל שלב בהפקת הסרטון.',
    'יכול לערוך כל שלב בהפקת הסרטון, לאשר או לדחות מעבר לבעל התפקיד הבא, למחוק סרטון ולנהל תפקידים לחברי הקבוצה.'
]

export function PopupRoles({ closePopup }) {
    return <div className="popup-roles">
        <h1>תפקידים והרשאות לפי סדר</h1>
        {Object.keys(rolesColors).map((role, idx) => <p key={idx}><span className={`${rolesColors[role]}-text`}>{rolesTranslations[role]}</span> : {explained[idx]}</p>)}
        <div className="buttons-wrapper">
            <button className="bolder" onClick={closePopup}>הבנתי</button>
        </div>
    </div>
}